import React, {FC} from 'react'
import { Segment, Menu, Checkbox } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { LKIcon } from 'loankeeper-common/components'

//@ts-ignore
import withLookups from 'shared/containers/withLookups'

import { NodeSharingProps } from '../../types'
const iconStyle = {
  marginRight: 5,
  width: 20,
  height: 20,
}

function renderIcon(currentNodeID: number, NodeID: number, nodesharing: any[]) {
  if (NodeID === currentNodeID) {
    return <LKIcon alias="today" style={iconStyle} />
  }

  if (nodesharing.find((node) => node.NodeID === currentNodeID)) {
    return <LKIcon alias="ok" style={iconStyle} />
  }

  return <div style={iconStyle} />
}

const NodeSharing: FC<NodeSharingProps> = ({ Nodes, NodeID, nodesharing }) => (
  <div className="u-flex u-directionColumn u-fluid">
    <Menu attached="top">
      <Menu.Item className="u-noPadding u-paddingRight-15 u-paddingLeft-5">
        <LKIcon alias="product" style={{ marginRight: 5 }} />

        {translate('frm_nodelist-frm_nodelist')}
      </Menu.Item>
    </Menu>

    <Segment className="u-marginBottom-5 u-noPadding u-overflowAuto u-fluid" attached="bottom">
      {Nodes.map((node) => (
        <div key={node.ID} className="u-padding-5 u-flex u-alignCenter">
          {renderIcon(node.ID, NodeID, nodesharing)}

          <span>{node.Title}</span>
        </div>
      ))}
    </Segment>

    <div className="u-flex u-alignCenter u-pullRight" style={{ minHeight: 31 }}>
      <Checkbox label={translate('frm_nodelist-chk_all')} />
    </div>
  </div>
)

export default withLookups({
  query: 'Nodes',
})(NodeSharing)
